"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YouTubeIcon = void 0;
const react_1 = __importDefault(require("react"));
const YouTubeIcon = (_a) => {
    var { fill } = _a, props = __rest(_a, ["fill"]);
    return (react_1.default.createElement("svg", Object.assign({ width: "33", height: "24", viewBox: "0 0 33 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { clipPath: "url(#clip0_213_22)" },
            react_1.default.createElement("path", { d: "M32.076 4.29053C31.8906 3.59305 31.5251 2.95658 31.0161 2.44495C30.5071 1.93332 29.8725 1.56451 29.176 1.37552C26.621 0.686519 16.376 0.686523 16.376 0.686523C16.376 0.686523 6.13202 0.686519 3.57602 1.37552C2.87956 1.5646 2.24503 1.93345 1.73605 2.44507C1.22707 2.95668 0.861511 3.5931 0.676023 4.29053C-0.236734 9.54216 -0.236734 14.9119 0.676023 20.1635C0.862802 20.8553 1.22957 21.4853 1.73898 21.9893C2.24839 22.4932 2.88225 22.8532 3.57602 23.0325C6.13102 23.7215 16.376 23.7215 16.376 23.7215C16.376 23.7215 26.62 23.7215 29.176 23.0325C29.8698 22.8532 30.5037 22.4932 31.0131 21.9893C31.5225 21.4853 31.8892 20.8553 32.076 20.1635C32.9888 14.9119 32.9888 9.54216 32.076 4.29053ZM13.03 17.1025V7.36053L21.592 12.2315L13.03 17.1025Z", fill: fill })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_213_22" },
                react_1.default.createElement("rect", { width: "32.76", height: "23.035", fill: fill, transform: "translate(0 0.69043)" })))));
};
exports.YouTubeIcon = YouTubeIcon;
